import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';

@Injectable({
   providedIn: 'root'
})

export class SEOService { 
   constructor(private meta: Meta) {
      // meta.addTag({name: 'description', content: 'Title and Meta tags examples'}, true); 
    }

    addMetaTags() {
      this.meta.addTags([
         {name: 'keywords', content: 'TypeScript, Angular'},
      ]);
 } 
} 